var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-bottom-navigation',{staticClass:"m-nav black",attrs:{"app":_vm.toggle,"input-value":_vm.toggle,"active-class":"active secondary--text"}},_vm._l((_vm.pages),function(page,key){return _c('v-btn',{key:'btn-'+key,staticClass:"btn",attrs:{"to":page.route,"exact":"","icon":"","tile":""}},[_c('v-icon',[_vm._v(_vm._s(page.icon))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }